<script setup>
import AppLogin from "@/components/Common/TheLoginEmail";
import {ref, onMounted} from "vue";
onMounted( ()=>{
  init()
})
const EVENT_NAME = ref('')
const init = async () => {
  EVENT_NAME.value = process.env.VUE_APP_EVENT_NAME
}
</script>
<template>
  <div class="card card-outline card-primary">
    <div class="card-header text-center">
      <p class="mt-3">{{ EVENT_NAME }}</p>
      <h3>Вход в систему</h3>
    </div>
    <div class="card-body">
      <AppLogin></AppLogin>
    </div>
  </div>
</template>
<style scoped>
</style>